const style = {
  display: "flex",
  gap: 8,
  alignItems: "center"
};

export function InputContainer(props) {
  return (<>
    <div style={ style }>{ props.children }</div>
  </>);
}
